"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
exports.RichText = function (props) {
    var children = props.children, className = props.className, size = props.size;
    var strippedHTML = children ? children.replace(/(<([^>]+)>)/gi, "") : null;
    var firstLine = children ? (children.indexOf(".") ? strippedHTML.split(".")[0] : strippedHTML) : null;
    var sizes = {
        normal: "text-base font-normal leading-tight tracking-none",
        serif: "text-base font-normal leading-tight tracking-none",
        mono: "text-base font-normal leading-normal tracking-none",
        small: "text-sm font-normal leading-tight tracking-none",
        xsmall: "text-xs font-normal leading-normal tracking-none",
        tiny: "text-xxs font-normal leading-normal tracking-none"
    };
    var style = size && sizes[size] ? sizes[size] : sizes.normal;
    var classes = "rte style-" + size + " " + style + (className ? " " + className : "");
    return (React.createElement("div", { className: classes }, props.firstLine ? (React.createElement("p", null, firstLine)) : props.strip || props.truncate ? (React.createElement("p", null, props.truncate ? next_components_1.ShopifyNext.Utils.truncateString(strippedHTML, props.truncate) : strippedHTML)) : (next_components_1.ShopifyNext.Utils.parseHTML(children))));
};
